import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import { API_CALL_STATUS } from '../../../reducers/status';
import axios from 'axios';




import { setAmcApplicationApiStatus } from '../../../actions/allSureMotorClaim/referenceData';
import { getClaimDetailsSummary } from '../../../selectors/allSureMotorClaim/confirmation';
import { getSubmittedAndRequiredDocs } from '../../../selectors/allSureMotorClaim/uploadDocuments';
import { getBasicDetailsForm } from '../../../selectors/allSureMotorClaim/basicDetails';
import { navigateToSuccessPage } from '../../../actions/allSureMotorClaim/routing';
import { getClaimName } from '../../../selectors/allSureMotorClaim/routing';

export const motoClaimSubmissionService = (store, next, action) => {
    const state = store.getState();
    (async () => {
        // try {
            store.dispatch(setAmcApplicationApiStatus({ type: 'apiStatus', value: API_CALL_STATUS.PENDING }));
            const productLabel = "Allsure Motor Claim"
            const claimDetailSummary = getClaimDetailsSummary(state);
            const { requiredDocuments,submittedDocuments} = getSubmittedAndRequiredDocs(state);
            const { fullName, mobileNumber, email, policyNumber } = getBasicDetailsForm(state);
            const personalDetails = {
                fullName: fullName.value,
                policyName: productLabel,
                uploadedDocuments: submittedDocuments,
                referenceNumber:policyNumber.value,
                requiredDocuments,
            };

            const dataEmailObj = [personalDetails, ...claimDetailSummary];

            const bussinessRequestBody = {
                firstName: fullName?.value?.split(' ')[0],
                lastName: fullName?.value?.split(' ')[1],
                contactNumber: mobileNumber?.value,
                subject: `Web: ${productLabel} : ${fullName?.value} - REF: ${policyNumber.value}`,
                userDataFields: dataEmailObj,
                templateType: 'ALLSURE_CLAIM_BUSINESS_EMAIL',
                referenceNumber: policyNumber.value ?? '',
                email: 'ALLSURE_CLAIM_BUSSINESS_MAIL',
            };
            const customerRequestBody = {
                firstName: fullName?.value?.split(' ')[0],
                lastName: fullName?.value?.split(' ')[1],
                contactNumber: mobileNumber?.value,
                subject: `Web: ${productLabel} : ${fullName?.value} - REF: ${policyNumber.value}`,
                userDataFields: dataEmailObj,
                templateType: 'ALLSURE_CLAIM_CUSTOMER_EMAIL',
                referenceNumber: policyNumber.value ?? '',
                email: email.value,
            };
            const quoteData = await sendEmailNotification(bussinessRequestBody);
            if (quoteData && quoteData.status === httpStatusCode.OK) {
                await sendEmailNotification(customerRequestBody);
                store.dispatch(setAmcApplicationApiStatus({ type: 'apiStatus', value: API_CALL_STATUS.SUCCESS }));
                store.dispatch(navigateToSuccessPage())
            } else {
                store.dispatch(setAmcApplicationApiStatus({ type: 'apiStatus', value: API_CALL_STATUS.FAILURE }));
            }
        // } catch (e) {
        //     store.dispatch(q({ type: 'apiStatus', value: API_CALL_STATUS.FAILURE }));
        // }
    })();
    return next(action);
};

export const sendEmailNotification = async (requestBody) => {
    try {
        const response = await axios({
            
            url: 'om-api/submit-notification/submitNotificationEmail',
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            data: requestBody,
        });
        return response;
    } catch (error) {
        return null;
    }
};
